"use strict";
var Observable_1 = require('../../Observable');
var never_1 = require('../../observable/never');
Observable_1.Observable.never = never_1.never;
//# sourceMappingURL=never.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/observable/never.js